import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NioCommonModule } from '../nio-common/nio-common.module';
import {
  CheckboxComponent,
  DateRangeComponent,
  FileDragDropComponent,
  GlobalWebviewAuthModalComponent,
  SearchComponent,
  StatusLegendComponent,
} from './components';
import {
  CellDirective,
  DataRowDefDirective,
  DataRowDirective,
  EmptyRowDefDirective,
  EmptyRowDirective,
  FooterRowDefDirective,
  FooterRowDirective,
  HeaderCellComponent,
  HeaderRowDefDirective,
  HeaderSortDirective,
  PanelBodyDirective,
  PanelComponent,
  PanelHeaderActionsDirective,
  PanelHeaderDirective,
  RowComponent,
  TableComponent,
} from './containers';
import {
  AppFileDnDDirective,
  BackButtonDirective,
  HasPermissionDirective,
  ImageLoadingDirective,
  SingleFileButtonDirective,
} from './directives';
import {
  ModalConfirmComponent,
  ModalCustomerInfoComponent,
  ModalPhotoViewerComponent,
  ModalUploadImagesComponent,
} from './modals';
import { FilterPipe, SortByPipe } from './pipes';

const declarations = [
  CellDirective,
  DataRowDefDirective,
  DataRowDirective,
  EmptyRowDefDirective,
  EmptyRowDirective,
  HeaderCellComponent,
  HeaderRowDefDirective,
  HeaderSortDirective,
  FooterRowDefDirective,
  FooterRowDirective,
  RowComponent,
  TableComponent,
  PanelBodyDirective,
  PanelComponent,
  PanelHeaderActionsDirective,
  PanelHeaderDirective,
  SortByPipe,
  FilterPipe,
  DateRangeComponent,
  StatusLegendComponent,
  CheckboxComponent,
  SearchComponent,
  BackButtonDirective,
  SingleFileButtonDirective,
  AppFileDnDDirective,
  HasPermissionDirective,
  ModalConfirmComponent,
  ModalCustomerInfoComponent,
  ModalPhotoViewerComponent,
  ModalUploadImagesComponent,
  FileDragDropComponent,
  ImageLoadingDirective,
  GlobalWebviewAuthModalComponent,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    NioCommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    NgxIntlTelInputModule,
  ],
  exports: [
    ...declarations,
    NioCommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgbModule,
    NgxIntlTelInputModule,
  ],
})
export class SharedModule {}
